import React from 'react';
import {
  DialogContent,
  makeStyles,
  FormControl,
  FormLabel,
  DialogActions,
  Button,
  Hidden,
  Radio,
  RadioGroup,
  FormControlLabel
} from '@material-ui/core';
import { ideaCreateActions, ideaCreateDialogsActions } from '../../actions';
import { DialogCustomTitle } from './DialogCustomTitle';
import { DialogCreateIdea } from './DialogCreateIdea';
import { dialogCss } from './dialogCss';

import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useWindowSize } from '../../hooks';
import { returnPage } from '../../helpers';
import { useForm } from 'react-hook-form';
import config from '../../config';
import clsx from 'clsx';
import { isEmpty } from "./../../utils/functions"

const useStyles = makeStyles(() => ({
  dividerBottom: {
    borderBottom: 'none',
  },
}));

function DialogAmbit() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();  
  const [width] = useWindowSize();
  const dialogClasses = dialogCss();
  const { handleSubmit, register } = useForm();
  const { suggestionsRegarding } = useSelector((state) => state.domains);
  const { selectedSuggestion } = useSelector((state) => state.ideaCreate);
  const { dialogAmbit, from } = useSelector((state) => state.ideaCreateDialogs);

  function createDraft() {
    if (suggestionsRegarding.length > 0) {
      dispatch(ideaCreateActions.createDraft(suggestionsRegarding));
    }
  }

  function previous() {
    returnPage(dispatch, from);
  }

  function onSubmit() {
    if (from === 'sendIdea') {
      dispatch(ideaCreateDialogsActions.openDialogSendIdea());
      return;
    }
    dispatch(ideaCreateDialogsActions.openDialogChallenge('DIALOG_AMBIT'));
  }

  function close() {
    if (width < config.RESPONSIVE_MOBILE) {
      dispatch(ideaCreateDialogsActions.openDialogClose());
    } else {
      dispatch(ideaCreateActions.clear());
      dispatch(ideaCreateDialogsActions.close());
    }
  }

  function selectedAmbit(suggestionsRegarding) {
    dispatch(ideaCreateActions.setAmbit(suggestionsRegarding));
  }

  return (
    <DialogCreateIdea open={dialogAmbit}>
      <DialogCustomTitle id="customized-dialog-title" onClose={close}>
        {t('onde_sua_ideia_vai_impactar')}
      </DialogCustomTitle>
      <DialogContent dividers className={classes.dividerBottom}>
        <FormControl component="fieldset" className={classes.formControl}>
          <FormLabel component="legend" className={dialogClasses.subtitle}>
            {t('selecione_o_principal_ambito_que_sera_impactado_pela_sua_ideia')}.
          </FormLabel>
          <RadioGroup aria-label="suggestions" name="suggestions">
            {suggestionsRegarding &&
              suggestionsRegarding.map((suggestions) => (
                <FormControlLabel
                  key={suggestions._id}
                  value={suggestions._id}
                  className={clsx(classes.label, dialogClasses.label)}
                  control={<Radio color="secondary" />}
                  onChange={() => selectedAmbit(suggestions)}
                  label={suggestions.name}
                  inputRef={register}
                  checked={selectedSuggestion?._id === suggestions?._id}
                />
              ))
            }
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions className={dialogClasses.containerAction}>
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div>
            {from && (
              <Button
                color="primary"
                onClick={previous}
                startIcon={<ArrowBackIcon />}
                className={dialogClasses.button}
              >
                {t('voltar')}
              </Button>
            )}
          </div>
          <div>
            <Hidden smDown>
              <Button
                className={dialogClasses.button}
                variant="outlined"
                color="primary"
                style={{ marginRight: 8 }}
                onClick={createDraft}
              >
                {t('salvar_rascunho')}
              </Button>
            </Hidden>
            <Button
              className={dialogClasses.button}
              variant="contained"
              type="submit"
              color="primary" 
              startIcon={<ArrowForwardIcon />}
              onClick={handleSubmit(onSubmit)}
            >
              {t('avancar')}
            </Button>
          </div>
        </div>
      </DialogActions>
    </DialogCreateIdea>
  );
}

export { DialogAmbit };